import request from '@/utils/request'


// 查询中奖邮寄地址列表
export function listLotteryAddress(query) {
  return request({
    url: '/biz/admin/lottery/lottery/address/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询中奖邮寄地址分页
export function pageLotteryAddress(query) {
  return request({
    url: '/biz/admin/lottery/lottery/address/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询中奖邮寄地址详细
export function getLotteryAddress(data) {
  return request({
    url: '/biz/admin/lottery/lottery/address/detail',
    method: 'get',
    params: data
  })
}

// 新增中奖邮寄地址
export function addLotteryAddress(data) {
  return request({
    url: '/biz/admin/lottery/lottery/address/add',
    method: 'post',
    data: data
  })
}

// 修改中奖邮寄地址
export function updateLotteryAddress(data) {
  return request({
    url: '/biz/admin/lottery/lottery/address/edit',
    method: 'post',
    data: data
  })
}

// 删除中奖邮寄地址
export function delLotteryAddress(data) {
  return request({
    url: '/biz/admin/lottery/lottery/address/delete',
    method: 'post',
    data: data
  })
}
